module.exports = __webpack_public_path__ + "static/hyperv_14.14830ba8.jpg";